<div class="university-card">
    <!-- Logo -->
    <div class="logo">
      <p-avatar
        *ngIf="!imageError && foto; else defaultAvatar"
        [image]="foto"
        shape="circle"
        size="large"
        (onImageError)="imageError = true"
      />
      <ng-template #defaultAvatar>
        <p-avatar
          [label]="getInitials(nome)"
          [icon]="!nome ? 'pi pi-user' : undefined"
          shape="circle"
          size="large"
        />
      </ng-template>
    </div>
  
    <!-- Name and Description -->
    <div class="details">
      <h3 class="name">{{ nome }}</h3>
      <div class="contact-info">
        <div class="info-item">
          <span>{{ designacao }} </span>
        </div>
      </div>
    </div>
  
    <div class="container-estado">
      <p-tag [value]="tipoProfissional" [severity]="getSeverity(tipoProfissional)"></p-tag>
    </div>
  
    <div class="extra-info">
      <div class="info-item">
        <!-- Icon -->
        <div class="icon">
            <i [class]="tipoProfissional | tipoProfissionalDesc:'icon'"></i>
        </div>
        <!-- Description -->
        <span class="info">{{ tipoProfissional | tipoProfissionalDesc:'text' }}</span>
      </div>
  
      <div class="info-item">
        <div class="icon">
          <img src="icons/clock.svg" alt="Ícone de clock" />
        </div>
        <span> {{ estado }}</span>
      </div>
    </div>
  
    <!-- Navigation Icon -->
    <div class="navigate">
      <img src="icons/arrow-right.svg" alt="Navigate Icon" />
    </div>
  </div>
  